import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import { Loader } from './components/ui/loader';
import { Layout } from './components/Layout';
import { ProtectedRoute, AdminOnly } from './components/ProtectedRoute';

import Login from './pages/Login';
import AcceptInvite from './pages/AcceptInvite';
import Questionnaire from './pages/Questionnaire';
import Dashboard from './pages/Dashboard';
import Campaigns from './pages/Campaigns';
import CampaignDetail from './pages/CampaignDetail';
import AuditDetail from './pages/AuditDetail';
import Toolkits from './pages/Toolkits';
import ToolkitDetail from './pages/ToolkitDetail';
import Documents from './pages/Documents';
import Settings from './pages/Settings';
import Help from './pages/Help';
import Support from './pages/Support';
import SupportTicketDetail from './pages/SupportTicketDetail';

import AdminHome from './pages/admin/AdminHome';
import AdminOrgs from './pages/admin/AdminOrgs';
import AdminOrgDetail from './pages/admin/AdminOrgDetail';
import AdminReleases from './pages/admin/AdminReleases';
import AdminGlobals from './pages/admin/AdminGlobals';
import AdminTickets from './pages/admin/AdminTickets';
import AdminTicketDetail from './pages/admin/AdminTicketDetail';

export default function App() {
  const { loading } = useAuth();
  if (loading) return <Loader fullscreen label="Chargement…" />;

  return (
    <Routes>
      {/* public */}
      <Route path="/login" element={<Login />} />
      <Route path="/invite/:inviteId" element={<AcceptInvite />} />

      {/* authenticated */}
      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        {/* ── Client portal ── */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/toolkits" element={<Toolkits />} />
        <Route path="/toolkits/:toolkitId" element={<ToolkitDetail />} />
        <Route path="/audits/:auditId" element={<AuditDetail />} />
        <Route path="/campaigns" element={<Campaigns />} />
        <Route path="/campaigns/:campaignId" element={<CampaignDetail />} />
        <Route path="/documents" element={<Documents />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/help" element={<Help />} />
        <Route path="/support" element={<Support />} />
        <Route path="/support/:ticketId" element={<SupportTicketDetail />} />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/upload" element={<Navigate to="/toolkits/audit?tab=upload" replace />} />
        <Route path="/reports" element={<Navigate to="/documents" replace />} />
        {/* /questionnaire list */}
        <Route path="/questionnaire" element={<Navigate to="/toolkits/audit?tab=questionnaire" replace />} />
        <Route path="/questionnaire/:questionnaireId" element={<Questionnaire />} />

        {/* ── Administration ── */}
        <Route path="/admin" element={<AdminOnly><AdminHome /></AdminOnly>} />
        <Route path="/admin/orgs" element={<AdminOnly><AdminOrgs /></AdminOnly>} />
        <Route path="/admin/orgs/:orgId" element={<AdminOnly><AdminOrgDetail /></AdminOnly>} />
        <Route path="/admin/releases" element={<AdminOnly><AdminReleases /></AdminOnly>} />
        <Route path="/admin/globals" element={<AdminOnly><AdminGlobals /></AdminOnly>} />
        <Route path="/admin/tickets" element={<AdminOnly><AdminTickets /></AdminOnly>} />
        <Route path="/admin/tickets/:ticketId" element={<AdminOnly><AdminTicketDetail /></AdminOnly>} />
      </Route>

      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
